import { render, staticRenderFns } from "./UploadSignImage.vue?vue&type=template&id=60b19567&scoped=true"
import script from "./UploadSignImage.vue?vue&type=script&lang=js"
export * from "./UploadSignImage.vue?vue&type=script&lang=js"
import style0 from "./UploadSignImage.vue?vue&type=style&index=0&id=60b19567&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b19567",
  null
  
)

export default component.exports